import { GRANTED_FPS, SHOW_STOPPER_EXTRA_FRAMES } from "../constants";

export const hasVideoGrantedExtraFrames = (actualFrameCount: number, RequiredLength: number) => {
    const extraFrames = actualFrameCount - (RequiredLength * GRANTED_FPS);
    const extraFramesPosNumber = extraFrames < 0 ? extraFrames * -1 : extraFrames;
    
    if (!extraFramesPosNumber) return true;

    return extraFramesPosNumber > 0 && extraFramesPosNumber <= SHOW_STOPPER_EXTRA_FRAMES;
};